module.exports = __webpack_public_path__ + "debcef832d21a7d833de8091f8de52c8.png";